// extracted by mini-css-extract-plugin
export default {"note":"style_note__i9K+9","withSideBar":"style_withSideBar__UB-Et"};